<!--
 * @Descripttion: 
 * @version: 倒计时组件
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: wlk
 * @LastEditTime: 2024-07-20 16:50:54
-->
<template>
  <div class="count-down send-sms-code-btn">
    <Button type="link" @click="sendSmsCode" v-if="!btnDisabled">{{ $lang('发送验证码') }}</Button>
    <Button type="link" :disabled="btnDisabled" v-else> {{ second }} s </Button>
  </div>
</template>
<script lang="ts" setup>
  import { onBeforeMount, onMounted, ref, watch } from 'vue'
  import { Button, message } from 'ant-design-vue'
  import { lang } from '@/utils/index'
  interface IFromProps {
    account: string
  }
  interface Props {
    /** 表单对象 */
    form: IFromProps
  }
  const props = defineProps<Props>()
  const emit = defineEmits(['openVerify'])
  const { form } = props
  let timer = null as any
  const second = ref(119)
  /** 按钮是否可点击，false可点击 */
  const btnDisabled = ref(false)

  /**
   * 发送短信验证前置检验
   * @param field 默认校验phone字段，如有特殊字段传入field
   */
  const sendSmsCode = (field: string) => {
    const account = form.account || form[field]
    if (!account) return message.error(lang('请输入邮箱'))
    /** 打开滑块验证码 */
    emit('openVerify')
  }

  /**
   * 开始倒计时
   */
  const handleCountDown = () => {
    timer = setInterval(() => {
      second.value -= 1
    }, 1000)
    btnDisabled.value = true
  }

  /**
   * 倒计时结束，按钮可点击
   */
  watch(
    () => second.value,
    () => {
      if (second.value < 0) {
        clearInterval(timer)
        btnDisabled.value = false
        second.value = 119
      }
    }
  )

  /**
   * 清空倒计时
   */
  onBeforeMount(() => {
    clearInterval(timer)
  })

  defineExpose({ handleCountDown })
</script>
<style lang="less" scoped></style>
